import { Component, EventEmitter, Input, Output } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { delay, Observable, of } from 'rxjs';
import { ChangeControlAttachmentDetails } from '../../../../../app/change-control/change-control-details/models/change-control-attachment-details';
import { ChangeControlDisplayDetails } from '../../../../../app/change-control/change-control-details/models/change-control-display-details';
import { ChangecontrolPersistenceService } from '../../services/changecontrol-persistence.service';
import { ChangeControlLibraryConstants } from '../../constants/changeControlLibraryConstants';
import { AssignmentGroupSharedDataService } from '../../../../../app/shared/services/assignment-group-shared-data.service';
import { ChangeControlPersistenceService } from '../../../../../app/change-control/change-control-details/services/change-control-persistence.service';
import { ChangeControlPhase } from '../../enums/change-control-phases';
import { SharedConstants } from '../../../../../app/shared/constants/shared-constants';

@Component({
  selector: 'app-change-control-files',
  templateUrl: './change-control-files.component.html',
  styleUrls: ['./change-control-files.component.scss']
})
export class ChangeControlFilesComponent {
  @Output() isChangeControlSliderActive = new EventEmitter<boolean>();
  @Input() isChangeControlSliderOpen: boolean = false;
  @Input() changeControlDetails !: ChangeControlDisplayDetails
  @Output() changeControlDataReload = new EventEmitter<boolean>();
  maxFileSize = ChangeControlLibraryConstants.Attachment_File_Max_Size;
  attachmentFileTypes: string = ChangeControlLibraryConstants.Attachments_File_Types;

  currentTab = 0;
  activeTab = 0;
  isChangeControlEditSlider = false;
  fileNamesToSave: any;
  attachmentsToSave: File[] = [];
  files: File[] = [];
  @Output() activateTabIndex = new EventEmitter<number>();
  deletedAttachments: ChangeControlAttachmentDetails[] = [];
  showDeletedFilesConfirmationModal = false;
  savedFiles: string[] = [];
  errorMessages: string[] = [];  
  fileNamesForAddAndDeleteOperations: string[] = [];
  // Tracks names removed via delete, kept separate so a same named reupload cannot undo the deletion
  private deletedAttachmentNames: string[] = [];
  changeControlSaveProgressMessage!:string;
  isChangeControlSaveInProgress!:boolean;
  fileAttachmentsHeaderText =
  ChangeControlLibraryConstants.ChangeControl_File_Attachments_Header_Text;
  deleteAttachmentConfirmationMessage: string =
    ChangeControlLibraryConstants.Deleted_Attachments_Confirmation_Message;
    isEditSlider: boolean = false;
    InactiveAssignmentGroupField : any;
    inactiveGroupsSelected : any;
    isInActiveAssignmentGroupDialog:boolean = false;
     isReasonRequired:boolean=false;
    isReasonForChangeControlUpdateRequired = false;
  reasonForChangeControlUpdate = '';
 heading: string = ChangeControlLibraryConstants.ReasonHeading;
  reasonValidationMessage: string = ChangeControlLibraryConstants.ReasonValidationMessage;
  changeControlAttachmentMaxLimit= SharedConstants.AttachmentMaxLimit;

constructor(private changecontrolPersistenceService: ChangecontrolPersistenceService, private assignmentGroupSharedDataService:AssignmentGroupSharedDataService,private  changeControlPersistenceService:ChangeControlPersistenceService)
{
}
ngOnInit()
{
  this.changecontrolPersistenceService.changeControlSaveInProgress$.subscribe(
    (changeControlSaveStatus) => {
      this.isChangeControlSaveInProgress = changeControlSaveStatus;
    }
  );
  if (this.changecontrolPersistenceService.isChangeControlEditSlider) {
    this.isEditSlider = true;
    this.calculateSavedFiles();
    this.changeControlSaveProgressMessage =
      ChangeControlLibraryConstants.ChangeControl_Update_InProgress;
  }

  this.changecontrolPersistenceService.currentTabInSliderMenuByCustomChange$.subscribe((tabIndex)=>{
    if(tabIndex == ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index){
      this.filesCalculation();
    }
  })
  this.changecontrolPersistenceService.currentTabInSliderMenu$.subscribe((tabIndex)=>{
    if(tabIndex == ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index){
      this.filesCalculation();
    }
  })
}

filesCalculation(){
  this.changecontrolPersistenceService.updateFileDetails(this.files);
  this.prepareDeletedAttachments();
  this.calculateSavedFiles();
}

  openCurrentTab = (tabIndex: any) => {
    this.currentTab = tabIndex;
    this.activeTab = tabIndex;
  }

  uploadSucceeds = (uploadedFiles: File[]): Observable<string[]> => {
    this.files = [...this.files, ...uploadedFiles];
    uploadedFiles.forEach((file) => {
      this.fileNamesForAddAndDeleteOperations.push(file.name);
    });
    const fileNames = uploadedFiles.map((i) => i.name);
    return of(fileNames).pipe(delay(3000));
  };

  deleteFile = (fileName: string): Observable<boolean> => {
    this.deleteAttachment(fileName);
    return of(true);
  };

  private deleteAttachment = (fileNameToDelete: string) => {
    this.files = this.files.filter((file) => {
      return file.name != fileNameToDelete;
    });
    this.fileNamesForAddAndDeleteOperations =
      this.fileNamesForAddAndDeleteOperations.filter((fileName) => {
        return fileName != fileNameToDelete;
      });
    if (this.deletedAttachmentNames.indexOf(fileNameToDelete) === -1) {
      this.deletedAttachmentNames.push(fileNameToDelete);
    }
  };


  openPreviousTab() {
    this.prepareDeletedAttachments();
    if(this.isChangeControlEditSlider){
      this.changecontrolPersistenceService.updateSavedChangeControls(this.changeControlDetails.attachments);
    }
    this.changecontrolPersistenceService.updateFileDetails(this.files);
    this.activateTabIndex.emit(
      ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index
    );
    this.changecontrolPersistenceService.onCustomTabChange(
      ChangeControlLibraryConstants.ChangeControl_Menu_General_Tab_Index
    );
  }

  createOrUpdateChangeControl = () => {
      this.errorMessages = [];
      if (this.errorMessages.length == 0) {
        this.prepareAddedAttachments();
        if (this.changecontrolPersistenceService.isChangeControlEditSlider) {
          this.changecontrolPersistenceService.updateTabErrorIndex(
            ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index,
            false
          );
          this.prepareDeletedAttachments();
           this.showConfirmationPopupForDeletedAttachments();
        } else {
          this.changecontrolPersistenceService.updateSaveInProgressStatus(true);
          this.changecontrolPersistenceService.updateFileDetails(this.files);
          this.changecontrolPersistenceService.updateChangeManagement();
        }
      } else if (this.isChangeControlEditSlider) {
        this.changecontrolPersistenceService.updateTabErrorIndex(
          ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index,
          true
        );
      }
  };

  closeConfirmationModal = () => {
    this.showDeletedFilesConfirmationModal = false;
  };


  UpdateChangeControl=()=>
  {
      this.showDeletedFilesConfirmationModal= false;
      this.validateInactiveUsersAndGroupsForUpdate();
  }



  showConfirmationPopupForDeletedAttachments = () => {
   const deletedAttachmentsRequiringConfirmation = this.deletedAttachments.filter((deletedAttachment) =>
      !this.files.some(
        file => file.name === deletedAttachment.attachmentPath
      )
    );

  if (deletedAttachmentsRequiringConfirmation.length > 0) {
      this.deletedAttachments = deletedAttachmentsRequiringConfirmation;    
      this.showDeletedFilesConfirmationModal = true;
    } 
    //This Else is used to show dialog for Reason to Edit and Inactive Groups 
    else {   
      this.validateInactiveUsersAndGroupsForUpdate();
    }
  }; 

  validateInactiveUsersAndGroupsForUpdate(){
    //Reset these values everytime
    this.changecontrolPersistenceService.updateFileDetails(this.files);
    this.inactiveGroupsSelected = undefined;
    this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(this.changecontrolPersistenceService.changeManagementDetails$.value,this.changecontrolPersistenceService.validatedUsersList,
      this.changecontrolPersistenceService.usersList
    );
    if(this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0){
      this.isInActiveAssignmentGroupDialog = true;   
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
     }
     else
     {
      this.isReasonRequired= false;
              this.isReasonRequired = [
              ChangeControlPhase.Implementation,
              ChangeControlPhase.Verification,
              ChangeControlPhase.Complete].includes(this.changeControlPersistenceService.currentPhaseOfChangeControl);
       if (this.isReasonRequired) {
          this.updateReasonForEditorSave();
        } 
        else{
            this.changecontrolPersistenceService.updateChangeManagement();
        }
      
     }
  }

    updateReasonForEditorSave() {
    const phasesToCheck = [
      ChangeControlPhase.Implementation,
      ChangeControlPhase.Verification,
      ChangeControlPhase.Complete
    ];
  
    if (phasesToCheck.includes(this.changeControlPersistenceService.currentPhaseOfChangeControl) && !this.reasonForChangeControlUpdate.length) {
      this.isReasonForChangeControlUpdateRequired = true;
    } else {
        this.changecontrolPersistenceService.updateChangeManagement();
    }
  }

  closeConfirmationDailog(value : boolean){    
    this.isInActiveAssignmentGroupDialog = value
  }
     closeReasonDailog(value: boolean) {
      this.isReasonForChangeControlUpdateRequired = value;
    }
 saveChangeControlwithReason(value: any) {
      this.reasonForChangeControlUpdate = value;
      this.isReasonForChangeControlUpdateRequired = false;
      this.changecontrolPersistenceService.reasonForChangeControlUpdate=this.reasonForChangeControlUpdate;
       this.changecontrolPersistenceService.updateChangeManagement();
    }

  saveChangeControlwithInactiveUsers(){
    this.isInActiveAssignmentGroupDialog = false;

    this.isReasonRequired= false;
              this.isReasonRequired = [
              ChangeControlPhase.Implementation,
              ChangeControlPhase.Verification,
              ChangeControlPhase.Complete].includes(this.changeControlPersistenceService.currentPhaseOfChangeControl);
       if (this.isReasonRequired) {
          this.updateReasonForEditorSave();
        } 
        else
        {
          this.changecontrolPersistenceService.updateChangeManagement();
        }
    
  }


  openNextTab = () => { 
    if (this.errorMessages.length === 0) {
      if (this.isEditSlider) {
        this.prepareDeletedAttachments();
        this.calculateSavedFiles();
        this.changecontrolPersistenceService.updateFileDetails(this.files);
        this.changecontrolPersistenceService.updateTabErrorIndex(ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index, false);
      }
      else{
        this.prepareDeletedAttachments();
        this.changecontrolPersistenceService.updateFileDetails(this.files);
      }
      this.activateTabIndex.emit(
        ChangeControlLibraryConstants.ChangeControl_Menu_RelatedDocoument_Tab_Index
      );
      this.changecontrolPersistenceService.onCustomTabChange(ChangeControlLibraryConstants.ChangeControl_Menu_RelatedDocoument_Tab_Index);
    } else {
      if (this.isEditSlider) {
        this.prepareDeletedAttachments();      
          this.calculateSavedFiles();
        this.changecontrolPersistenceService.updateFileDetails(this.files);
        this.changecontrolPersistenceService.updateTabErrorIndex(ChangeControlLibraryConstants.ChangeControl_Menu_File_Tab_Index, true);
        this.activateTabIndex.emit(
          ChangeControlLibraryConstants.ChangeControl_Menu_RelatedDocoument_Tab_Index
        );
        this.changecontrolPersistenceService.onCustomTabChange(ChangeControlLibraryConstants.ChangeControl_Menu_RelatedDocoument_Tab_Index);
      }
      else
        document.querySelector('.p-tabview-panels')?.scrollTo(0, 0);
    }
  };



  private prepareDeletedAttachments = () => {
    this.deletedAttachments = [];
    let savedAttachments = cloneDeep(
      this.changecontrolPersistenceService.savedChangeControlAttachments
    );
    let deletedAttachments = savedAttachments?.filter((savedAttachment) => {
      return this.deletedAttachmentNames.indexOf(savedAttachment.attachmentPath) !== -1;
    });
    if (!!deletedAttachments && deletedAttachments.length > 0) {
      this.deletedAttachments = deletedAttachments;
    }
    this.changecontrolPersistenceService.updateDeletedAttachments(
      deletedAttachments
    );
  };

  private prepareAddedAttachments = () => {
    // savedFiles never drops deleted names and exclude only truly deleted names so a reupload with that name is not treated as already saved.
    const activeSavedFileNames = this.savedFiles.filter((name) =>
      this.deletedAttachmentNames.indexOf(name) === -1
    );
    this.files = this.files.filter((file) => {
      return activeSavedFileNames.indexOf(file.name) === -1;
    });
  };

   calculateSavedFiles = () => {
    this.changecontrolPersistenceService.changeManagementDisplayDetails$.subscribe(changeControlDetail=>{
      changeControlDetail?.attachments?.forEach(
        (attachment) => {
          this.savedFiles.push(attachment.attachmentPath);
          // If there is any attachment deleted from the existing uploaded file
          if(this.changecontrolPersistenceService.deletedChangeControlAttachments !== null && this.changecontrolPersistenceService.deletedChangeControlAttachments !== undefined && this.changecontrolPersistenceService.deletedChangeControlAttachments.length > 0){
            //To find the iteration on which the file was deleted based on file name
            if(!this.changecontrolPersistenceService.deletedChangeControlAttachments.some(i => i.attachmentPath === attachment.attachmentPath && i.fileId === attachment.fileId))
              this.fileNamesForAddAndDeleteOperations.push(attachment.attachmentPath);
          }
          else
            this.fileNamesForAddAndDeleteOperations.push(attachment.attachmentPath);
          if(this.changecontrolPersistenceService.savedChangeControlAttachments.find(i=>i.fileId == attachment.fileId) == null)
            {
              this.changecontrolPersistenceService.savedChangeControlAttachments.push(attachment);
            }
        }
      );
    });
  }
}
